<script setup>
import { useBlocksText } from "#strapi-blocks-renderer/composables/useBlocksText";
const props = defineProps({
  nodes: { type: Array, required: true }
});
const { text } = useBlocksText(props.nodes);
const RenderText = () => {
  return text;
};
</script>

<template>
    <RenderText />
</template>
